import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import axios from 'axios'
import { message } from 'antd'

export function createRequest(config?: AxiosRequestConfig): AxiosInstance {
  const instance = axios.create({
    timeout: 10000,
    withCredentials: true,
    ...config,
  })
  instance.interceptors.request.use(
    (config: any) => {
      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )

  instance.interceptors.response.use(
    (response: any) => {
      const { code, data, message: messageR } = response.data
      if (code === 200) {
        return response.data
      }
      else if (code === 401) {
        message.error(messageR)
        return Promise.reject(response.data)
      }
      else {
        return response.data
      }
    },
    (error) => {
      if (error.response) {
        if (error.response.status === 401) {
          message.error('Login failed, please log in again')
        }
      }
      message.error(error?.response?.data?.message || 'server error')
      return Promise.reject(error)
    },
  )
  return instance
}
